export const today = require("./dashboard_information_today.json");
export const yesterday = require("./dashboard_information_yesterday.json");
export const week = require("./dashboard_information_week.json");
export const month = require("./dashboard_information_month.json");
